export default __webpack_public_path__ + "static/app-menu-c6c611aadbb500f908d486b3a5a2713c.jpg";